import { cn } from '@workspace/lib';
import type { SanityImage } from '@workspace/interfaces';
import { AppImage } from '@/app/common';

interface GalleryThumbnailsProps {
  gallerySlides: SanityImage[];
  emblaRef: (node: HTMLDivElement | null) => void;
  buildImageUrl: (img: SanityImage | undefined, width: number, height: number) => string;
  onImageClick: (index: number) => void;
}

export const GalleryThumbnails = ({ gallerySlides, emblaRef, buildImageUrl, onImageClick }: GalleryThumbnailsProps) => {
  return (
    <div className="w-full overflow-hidden mt-6 md:mt-0" ref={emblaRef}>
      <div className={cn('flex flex-row')}>
        {gallerySlides.map((img, index) => (
          <div key={index} className="shrink-0 md:ml-sm">
            <AppImage
              src={buildImageUrl(img, 305, 305)}
              alt={img.bynderImage?.alt || img.alt || 'img'}
              width={305}
              height={305}
              onClick={() => onImageClick(index)}
              className="w-[305px] h-[305px] cursor-pointer"
            />
          </div>
        ))}
      </div>
    </div>
  );
};
